import { GIVEAWAY_PATH_PREFIX } from '@/lib/slug'
import { cn } from '@/lib/cn'

interface SlugFieldProps {
  slug: string
  onChange: (value: string) => void
  /** Restores the slug derived from the giveaway's name. */
  onReset?: () => void
  error: string | null
  previewUrl: string
}

/**
 * The shareable link for a giveaway, edited in place with the address shown as
 * it will be shared. Used both when creating a giveaway and when editing one.
 */
export function SlugField({ slug, onChange, onReset, error, previewUrl }: SlugFieldProps) {
  return (
    <div className="field-row slug-field">
      <div className="field">
        <div className="field-name">Share link</div>

        <div className={cn('field-box', error && 'has-error')}>
          <div className="field-box-prepend slug-prefix">{GIVEAWAY_PATH_PREFIX}/</div>
          <input
            className="field-box-input slug-input"
            aria-label="Giveaway link"
            aria-invalid={error !== null}
            aria-describedby="slug-help"
            spellCheck={false}
            autoCapitalize="none"
            autoCorrect="off"
            value={slug}
            onChange={(event) => onChange(event.target.value)}
          />
          {onReset ? (
            <button
              type="button"
              className="field-box-append slug-reset"
              title="Use the giveaway name"
              onClick={onReset}
            >
              Reset
            </button>
          ) : null}
        </div>

        <div id="slug-help" className={cn('slug-help', error && 'is-error')}>
          {error ?? previewUrl}
        </div>
      </div>
    </div>
  )
}
